import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <img
                  src={props.data ? props.data.image : "loading-image.png"}
                  alt="StuDev Logo"
                  className="header-image"
                  style={{ height: '150px'}}
                />
                <p><strong>{props.data ? props.data.paragraph : "Loading"}</strong></p>
                <a
                  href="#about"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
